var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3223 13.3208L27.5526 15.9825C28.406 17.6847 28.8239 19.572 28.7686 21.4753C28.7134 23.3787 28.1868 25.2386 27.2361 26.8884H7.29463C6.05896 24.7448 5.54694 22.2601 5.83447 19.8025C6.122 17.345 7.19378 15.0456 8.89092 13.2451C10.5881 11.4446 12.8202 10.239 15.2564 9.80684C17.6927 9.37471 20.2033 9.73913 22.4162 10.8461L25.0779 9.07638C22.3679 7.33865 19.1535 6.55997 15.9487 6.86489C12.7439 7.16981 9.73399 8.54072 7.40037 10.7583C5.06674 12.9759 3.54426 15.9121 3.07645 19.0972C2.60864 22.2823 3.22253 25.5322 4.81993 28.3272C5.07102 28.7621 5.43154 29.1237 5.86568 29.3761C6.29982 29.6285 6.79246 29.7629 7.29463 29.766H27.2217C27.7287 29.768 28.2273 29.636 28.6669 29.3833C29.1066 29.1307 29.4716 28.7663 29.7251 28.3272C31.0508 26.0308 31.7161 23.4127 31.6475 20.762C31.579 18.1114 30.7792 15.5312 29.3367 13.3064L29.3223 13.3208Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2366 23.1617C15.5039 23.4292 15.8213 23.6415 16.1706 23.7863C16.5199 23.9311 16.8944 24.0056 17.2725 24.0056C17.6507 24.0056 18.0251 23.9311 18.3744 23.7863C18.7238 23.6415 19.0411 23.4292 19.3084 23.1617L27.4519 10.9465L15.2366 19.09C14.9691 19.3572 14.7569 19.6746 14.612 20.0239C14.4672 20.3732 14.3927 20.7477 14.3927 21.1258C14.3927 21.504 14.4672 21.8784 14.612 22.2278C14.7569 22.5771 14.9691 22.8945 15.2366 23.1617Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineSpeed);
export default __webpack_public_path__ + "static/media/ic_outline-speed.41dc8ccb2c1ed9858344304d9f0ecdb3.svg";
export { ForwardRef as ReactComponent };